import React, { useState } from 'react';
import AdminStockOrderSection from './AdminStockOrderSection';
import ContactManagement from './ContactManagement';
import CategoryManagement from './CategoryManagement';

const SimpleAccessManagement = () => {
    const [activeTab, setActiveTab] = useState('stock');

    return (
        <div className="simple-access-management">
            <div className="tab-navigation" style={{ 
                display: 'flex', 
                borderBottom: '2px solid #ddd', 
                marginBottom: '20px' 
            }}>
                <button 
                    onClick={() => setActiveTab('stock')}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: activeTab === 'stock' ? '#007cba' : '#f5f5f5',
                        color: activeTab === 'stock' ? 'white' : '#333',
                        border: 'none',
                        borderRadius: '5px 5px 0 0',
                        cursor: 'pointer',
                        marginRight: '5px'
                    }}
                >
                    Stock Management
                </button>
                <button 
                    onClick={() => setActiveTab('contacts')}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: activeTab === 'contacts' ? '#007cba' : '#f5f5f5',
                        color: activeTab === 'contacts' ? 'white' : '#333',
                        border: 'none',
                        borderRadius: '5px 5px 0 0',
                        cursor: 'pointer',
                        marginRight: '5px'
                    }}
                >
                    Contact Viewer
                </button>
                <button 
                    onClick={() => setActiveTab('categories')}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: activeTab === 'categories' ? '#007cba' : '#f5f5f5',
                        color: activeTab === 'categories' ? 'white' : '#333',
                        border: 'none',
                        borderRadius: '5px 5px 0 0',
                        cursor: 'pointer'
                    }}
                >
                    Category Visibility
                </button>
            </div>

            <div className="tab-content">
                {activeTab === 'stock' && <AdminStockOrderSection />}
                {activeTab === 'contacts' && <ContactManagement />}
                {activeTab === 'categories' && <CategoryManagement />}
            </div>
        </div>
    );
};

export default SimpleAccessManagement;
